export const INSIGHTS_LANDING_VIEW_STORAGE_KEY = "gri.insights.landingView";

export type InsightsLandingView = "list" | "card";

export function readInsightsLandingView(
  storage: Pick<Storage, "getItem"> | null = globalThis.localStorage,
): InsightsLandingView {
  try {
    return storage?.getItem(INSIGHTS_LANDING_VIEW_STORAGE_KEY) === "card"
      ? "card"
      : "list";
  } catch {
    return "list";
  }
}

export function writeInsightsLandingView(
  view: InsightsLandingView,
  storage: Pick<Storage, "setItem"> | null = globalThis.localStorage,
): void {
  try {
    storage?.setItem(INSIGHTS_LANDING_VIEW_STORAGE_KEY, view);
  } catch {
    // Remembering the view is best-effort on this browser.
  }
}
